<template>
  <div :class="wrapSize">
    <div :class="labelWrap" v-if="label">
      <label :for="labelFor" class="inline-block text-80 leading-tight">{{label}}</label>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
    name: 'InputControl',

    props: {
        wrapSize: {
            type: String,
            default: 'mb-6',
        },
        labelWrap: {
            type: String,
            default: 'mb-2',
        },
        label: {
            type: String,
            default: '',
        },
        labelFor: {
            type: String,
            default: '',
        },
    },
};
</script>
